import { render, staticRenderFns } from "./WarningBadge.vue?vue&type=template&id=0af3efbb&scoped=true"
import script from "./WarningBadge.vue?vue&type=script&lang=js"
export * from "./WarningBadge.vue?vue&type=script&lang=js"
import style0 from "./WarningBadge.vue?vue&type=style&index=0&id=0af3efbb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af3efbb",
  null
  
)

export default component.exports